import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const China = () => {
    return <SharedDocumentsComponent permissionId="38" path="China" />
}